import type { DropdownMenuItem, FormType } from "../../../components/types";
import type { FC } from "react";
import type { SelectChangeEvent } from "@mui/material";

import CircularProgressBox from "../../../components/CircularProgressBox";
import CampaignSettingsCustom from "./CampaignSettingsCustom";
import CustomButton from "../../../components/CustomButton";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";

interface CampaignSettingsProps {
  isFetching: boolean;
  isLoading: boolean;
  forms: FormType[];
  menuItems: DropdownMenuItem[];
  alignment: "all" | "custom";
  handleFormControlChange: (event: SelectChangeEvent, index: number) => void;
  handleAlignmentChange: (_: any, newAlignment: "all" | "custom") => void;
  getValuesToHide: (forms: FormType[]) => string[];
  onDeleteForm: (index: number) => void;
  onAddFormIncludeChip: (formIndex: number, values: string[]) => void;
  onAddExcludeChip: (formIndex: number, values: string[]) => void;
  onSaveChanges: () => void;
  addEmptyPairingForm: () => void;
}

export const CampaignSettings: FC<CampaignSettingsProps> = ({
  isFetching,
  alignment,
  forms,
  menuItems,
  addEmptyPairingForm,
  getValuesToHide,
  handleAlignmentChange,
  handleFormControlChange,
  onAddExcludeChip,
  onAddFormIncludeChip,
  onDeleteForm,
}) => {
  const { t } = useTranslation();

  return isFetching ? (
    <CircularProgressBox />
  ) : (
    <>
      <ToggleButtonGroup
        value={alignment}
        exclusive
        defaultValue={alignment}
        onChange={handleAlignmentChange}
        sx={{
          padding: "16px 0",
        }}
      >
        <ToggleButton value='all' aria-label='show everywhere'>
          {t("campaign.settings.all")}
        </ToggleButton>
        <ToggleButton value='custom' aria-label='custom selection'>
          {t("campaign.settings.custom")}
        </ToggleButton>
      </ToggleButtonGroup>
      {alignment === "custom" ? (
        <CampaignSettingsCustom
          forms={forms}
          menuItems={menuItems}
          addEmptyPairingForm={addEmptyPairingForm}
          getValuesToHide={getValuesToHide}
          handleFormControlChange={handleFormControlChange}
          onAddExcludeChip={onAddExcludeChip}
          onAddFormIncludeChip={onAddFormIncludeChip}
          onDeleteForm={onDeleteForm}
        />
      ) : (
        <Box
          sx={{
            height: 395,
          }}
        >
          <Typography
            maxWidth={700}
            fontStyle='italic'
            sx={{ marginBottom: 2 }}
          >
            {t("campaign.settings.allDescription")}
          </Typography>
        </Box>
      )}
    </>
  );
};
